var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "col-12",
      on: {
        click: function($event) {
          return _vm.$emit("template-selected")
        }
      }
    },
    [
      _c("div", { staticClass: "row" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "col-7" }, [
          _c("span", { staticClass: "template-name-label" }, [
            _vm._v(_vm._s(_vm.name))
          ]),
          _vm._v(" "),
          _c(
            "span",
            { staticClass: "sub-text-label" },
            [
              _vm._t("sub-text-label", null, {
                formattedDate: _vm.formattedDate
              })
            ],
            2
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-3 text-right icon-container" },
          [
            _vm.canEdit
              ? _c(
                  "a",
                  {
                    staticClass: "mdb-icon-btn edit",
                    attrs: { href: _vm.editUrl },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                      }
                    }
                  },
                  [
                    _c("i", {
                      staticClass: "fa fa-pencil fa-lg mr-1",
                      attrs: { "aria-hidden": "true" }
                    })
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm._t("additional-controls"),
            _vm._v(" "),
            _vm.canDelete
              ? _c("i", {
                  staticClass: "fa fa-trash mdb-icon-btn delete fa-lg",
                  attrs: { "aria-hidden": "true" },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.promptDeleteRecord($event)
                    }
                  }
                })
              : _vm._e()
          ],
          2
        )
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-2 icon-container" }, [
      _c("i", {
        staticClass: "fa fa-2x fa-user-circle",
        attrs: { "aria-hidden": "true" }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }